// src/utils/detectSocialMediaPlatform.js
const detectSocialMediaPlatform = (url) => {
  if (!url || typeof url !== "string") return null;

  const normalizedUrl = url.toLowerCase().replace(/^https?:\/\//, "");

  const platformPatterns = [
    { name: "Reddit", pattern: /^(www\.)?(reddit\.com|redd\.it)\// },
    { name: "WhatsApp", pattern: /^(www\.)?(whatsapp\.com|wa\.me)\// },
    { name: "Pinterest", pattern: /^(www\.)?(pinterest\.com|pin\.it)\// },
    { name: "Snapchat", pattern: /^(www\.)?(snapchat\.com|sc\.co)\// },
    { name: "LinkedIn", pattern: /^(www\.)?(linkedin\.com)\// },
    { name: "YouTube", pattern: /^(www\.)?(youtube\.com|youtu\.be)\// },
    { name: "TikTok", pattern: /^(www\.)?(tiktok\.com)\// },
    { name: "Twitter", pattern: /^(www\.)?(twitter\.com|x\.com)\// },
    { name: "Instagram", pattern: /^(www\.)?(instagram\.com)\// },
    {
      name: "Facebook",
      pattern: /^(www\.)?(facebook\.com|fb\.com|m\.facebook\.com)\//,
    },
    { name: "Vimeo", pattern: /^(www\.)?(vimeo\.com)\// },
  ];

  for (const platform of platformPatterns) {
    if (platform.pattern.test(normalizedUrl)) {
      return platform.name;
    }
  }

  return null;
};

export default detectSocialMediaPlatform;
